import axios from 'axios';
import _ from 'lodash';
import {
    rootUrl
} from './config';
import lang_product_detail from '../../lang/webshop_product_detail.json';


function productSKUPriceEventsBinding() {
  $("button[name='product_share_link_copy']").on("click", function (evt) {
    evt.stopPropagation();
    var copyText = document.getElementById("product_refreral_link");
    copyText.select();
    copyText.setSelectionRange(0, 99999); // For mobile devices
    navigator.clipboard.writeText(copyText.value);
    $(this).find("i.bi").removeClass("bi-clipboard").addClass("bi-clipboard-check");
  });

  $(`button.product-variation[name=color]`).on('mouseenter',function(){
    updateImgSlickSlide(this);
  }).on("mouseleave",function(){
    rollbackImgSlickSlide(this);
  });
  $("button.product-variation").on("click",function(evt) {
    evt.stopPropagation();
    updateImgSlickSlide(this);
    if(isWaittingServer()) return false;
    startWaittingServer();
    let optName = $(this).attr("name");
        
    let optionNames = sessionStorage.getItem("stackoptionname");
    optionNames = optionNames ? optionNames.split(',') : [];

    if($(this).hasClass("skubuttonselected")){
      //the button clicked at second times
      _.remove(optionNames,(value, index) =>{return value===optName;});
      $(this).removeClass('skubuttonselected');
      sessionStorage.setItem("stackoptionname", optionNames.toString());
      clearAllPriceSKUHtml();
    }else{
      let indexCurrentOpt = _.indexOf(optionNames, optName);
      if(indexCurrentOpt === -1){
        //first click on the option
        optionNames.push(optName);
        sessionStorage.setItem("stackoptionname", optionNames.toString());
      }else{
        if(indexCurrentOpt < optionNames.length -1){
          //none-first click on the option
          for (let i = optionNames.length-1; i > indexCurrentOpt; i--) {
            $(`button.product-variation.skubuttonselected[name=${optionNames[i]}]`).removeClass('skubuttonselected');
            optionNames = _.dropRight(optionNames);
          }
          sessionStorage.setItem("stackoptionname", optionNames.toString());
        }
        $(`button.product-variation.skubuttonselected[name=${optName}]`).removeClass('skubuttonselected');
      }
      $(this).addClass('skubuttonselected');
    }
    if(optionNames){
      getSelectedSKU(this, $(this).closest("div.sku-info").data("pid"), optionNames);
    }
  });
}

function updateImgSlickSlide(ele){
  let indexImageSkuInfo  = $(ele).data("idximg");
  indexImageSkuInfo = isNaN(indexImageSkuInfo) ? 0 : Number(indexImageSkuInfo);
  if($(ele).attr("name") == "color" && indexImageSkuInfo > 0){
    $(ele).data("old-slide-index",$("#id-sku-img-slick-slide").slick('slickCurrentSlide').toString());
    $("#id-sku-img-slick-slide").slick('slickGoTo',(indexImageSkuInfo - 1),true);
  }
}
function rollbackImgSlickSlide(ele){
  let preIndexSlick  = $(ele).data("old-slide-index");
  preIndexSlick = isNaN(preIndexSlick) ? -1 : Number(preIndexSlick);
  if($(ele).attr("name") == "color" && preIndexSlick > -1){
    $("#id-sku-img-slick-slide").slick('slickGoTo',preIndexSlick,true);
  }
}
function updateDetailInfo(ele, data, sel) {
  preUpdateHtml(data);
  //console.log("Selected: ",sel);
  if(sel.isDone && sessionStorage.getItem("isdoneselection") && !_.isEqual(sel.vals, {})){
    let selSKU = _.find(data.skus, sel.vals);
    //console.log("Selected SKU: ",selSKU);
    if(selSKU){
      $("#lang_price").css("visibility","visible");
      $("#lang_out_stock").css("visibility","hidden");
      $("#sku_id_span").html(selSKU.sku);
      $("#id_percentage_reseller_discount").text(selSKU.reseller_discount+"%");
      $("#id_percentage_super_reseller_discount").text(selSKU.super_reseller_discount+"%");
      if(Number(selSKU.sale_price)>0){
        $("#sku_selected_price").html(selSKU.show_sale_price);
        $("#sku_was_price").html(selSKU.show_price);
      }else{
        $("#sku_selected_price").html(selSKU.show_price);
        $("#sku_was_price").html("");
      }

      if(Number(selSKU.stock)>0){
        $("#num_product_in_stock").css("visibility","visible");
        $("#num_product_in_stock span.number").text(`${selSKU.stock}`);
      }else{
        $("#num_product_in_stock").css("visibility","hidden");
      }
      $("div.addcart button[name='prod_add2bakset']").attr("data-pid",selSKU.sku_id);
      return;
    }else{
      $("#lang_out_stock").css("visibility","visible");
      $("#lang_price").css("visibility","hidden");
    }
  }
  $("div.addcart button[name='prod_add2bakset']").attr("data-pid","_not_selected");
  $("#sku_was_price").html("");
}

function isDoneSelected(numOption) {
  let result={isDone: false, msg: lang_product_detail.product_detail.not_selected_done, max_groupbtn: 0};

  let maxNumOption = $(".product-info .price-stock .ps-left .sku-info .groupbuttonsku").length;
  result.max_groupbtn = maxNumOption;
  if(numOption === maxNumOption){
    result.isDone = true;
    result.msg = lang_product_detail.product_detail.selected_done;
  }
  return result;
}

async function getSelectedSKU(ele, pId, optionNames) {
  let vals = {};
  let currentOptName=$(ele).attr("name");
  let currentOrder = _.indexOf(optionNames, currentOptName);
  if(currentOrder === -1){
    currentOrder = optionNames.length-1;
    currentOptName = optionNames[currentOrder];
  }
  let numOption = _.size(optionNames);
  let statusSelected = isDoneSelected(numOption);

  let url = `${rootUrl}/product/selectsku?pId=${pId}&isDone=${statusSelected.isDone}&currentOpt=${currentOrder}`;
  _.map(optionNames,(item, index)=>{
    vals[`${item}_id`] = $(`button.product-variation.skubuttonselected[name=${item}]`).attr("value");
    url = `${url}&optName=${item}&optVal=${vals[item+"_id"]}`;
  });
  statusSelected["vals"]= vals;

  updateStatusToStorage(statusSelected.isDone);

  const {data, status} = await axios({ url: url, method: 'GET'});
  stopWaittingServer();
  if(data && data.status && data.skus){
    // console.log("Data from getSelectedSKU()",{data});
    $(`.product-info .price-stock .ps-left .sku-info .groupbuttonsku`).each(function(idx, groupbuttonsku){
      let itemName = $(groupbuttonsku).data("optname");
      let itemOrder = _.indexOf(optionNames, itemName);
      if(Number(itemOrder) === 0){
        updateFirstSelectedOption(groupbuttonsku, data.opts, itemName, itemOrder);
      }
      if((Number(itemOrder) === -1) || Number(itemOrder) > Number(currentOrder)){
        updateOpts(groupbuttonsku, data, itemName, optionNames);
      }

    });
    updateDetailInfo(ele, data, statusSelected);
  }
}

function updateOpts(ele, data, optName, optionNamesClient) {
  $(ele).find("button.product-variation").attr("disabled","disabled");
  $.each(data.skus, function(idx, it) {
    let foundOpt = $(ele).find(`button.product-variation[value='${it[optName+"_id"]}']`);
    if(foundOpt) {
      foundOpt.removeAttr("disabled");
    }
  });

  //in case delay of server, user click the button before it is disable by updateDetailInfo()
  $(ele).find("button.product-variation:disabled").each(function(idx, btndisable){
    if ($(btndisable).hasClass("skubuttonselected")){
      $(btndisable).removeClass("skubuttonselected");
      _.remove(optionNamesClient,(value) =>{return value===optName;});
      sessionStorage.setItem("stackoptionname", optionNamesClient.toString());
      sessionStorage.removeItem("isdoneselection");
      clearAllPriceSKUHtml();
    }
  });
}

function updateStatusToStorage(isDone){
  if(isDone){
    sessionStorage.setItem("isdoneselection", true);
    $(".product-info .price-stock .ps-left .sku-info").removeClass("warning-user");
    $("#remind-customer-sku").remove();
  }else{
    sessionStorage.removeItem("isdoneselection");
  }
}

function updateFirstSelectedOption(ele, optionsFromServer, optName, optOder){
  let currentOption = _.find(optionsFromServer,{"name":optName});
  let numberOfBtn = 0;
  $(ele).find("button.product-variation").each(function(idx, btn){
    numberOfBtn++;
    _.each(currentOption.items, function(it){
      if(it.val === $(btn).attr("value")){
        it.isExistBtn = true;
        if(it.isOn) $(btn).removeAttr("disabled");
        return false;
      }
    });
  })
}

function clearDataForProductDetail(){
  if(!$("button.product-variation.skubuttonselected").length !== 0){
    sessionStorage.removeItem("stackoptionname");
    sessionStorage.removeItem('isWaittingServer');
    sessionStorage.removeItem("isdoneselection");
  }
}

function isWaittingServer(){
  return sessionStorage.getItem('isWaittingServer');
}
function startWaittingServer(){
  sessionStorage.setItem('isWaittingServer', true);
}
function stopWaittingServer(){
  sessionStorage.removeItem('isWaittingServer');
}

function clearAllPriceSKUHtml(){
  $("div.addcart button[name='prod_add2bakset']").attr("data-pid","_not_selected");
  $("#sku_selected_price").html("");
  $("#sku_was_price").html("");
  $("#lang_out_stock").css("visibility","hidden");
  $("#sku_id_span").html("");
  $("#num_product_in_stock").css("visibility","hidden");

}
function  preUpdateHtml(data){
  $("#num_product_in_stock").css("visibility","hidden");
  $("#sku_selected_price").html(data.show_range_price);
  if(data.sumStock > 0){
    $("#num_product_in_stock").css("visibility","visible");
    $("#num_product_in_stock span.number").text(`${data.sumStock }`);
  }
}
export { productSKUPriceEventsBinding, clearDataForProductDetail};